import { lazy } from 'react'
import i18n from 'common/i18n'
import { lazyRetry } from '../help/utils'

const ImportsExportsDashboard = lazy(() => lazyRetry(() => import('containers/Dashboards/ImportsExportsDashboard')))

const route = [
  {
    name: i18n.t('routes.inconsistenciesDashboard.index'),
    path: '/imports-exports-dashboard',
    main: ImportsExportsDashboard,
    exact: true,
    permissions: ['ROLE_VISUALIZAR_DASHBOARD_IMPORTS_EXPORTS']
  }
]

export default route
